var map = {
	"./account.svg": "0c00",
	"./advdeal.svg": "557d",
	"./arrowdown.svg": "ec30",
	"./bell.svg": "8fda",
	"./bitcoin.svg": "d191",
	"./dashboard.svg": "6912",
	"./deal.svg": "e12c",
	"./deal2.svg": "aeca",
	"./ezdeal.svg": "e846",
	"./gear.svg": "6af4",
	"./history.svg": "ca51",
	"./invite.svg": "f551",
	"./login.svg": "ac22",
	"./logout.svg": "7428",
	"./money.svg": "9d30",
	"./perfectmoney.svg": "7102",
	"./wallet.svg": "abd1",
	"./webmoney.svg": "34b3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "47bb";